
var jModal = ($) => {

  if (!window.Tangible) return
  var ajax = window.Tangible.ajax
  var ajaxConfig = window.Tangible.ajaxConfig

  // Global object
  window.tgblModal = {}

  $(document).ready(function () {
    window.tgblModal.modal.constructor()
  })

  window.tgblModal.modal = {
    // initialize the code
    constructor: function () {
      // Add events for the group management page
      this.modalEvents();
    },


    modalEvents: function () {
      $('body').on( 'click','.certificate-modal-link a', this.openCertModal);
      $('body').on( 'click','.tgbl_certificate_email', this.openEmailPdfModal);
    },


    openEmailPdfModal: function (e) {
      e.preventDefault();
      $(this).modal({
        fadeDuration: 250,
        closeExisting: false
      });
      return false;
    },


    openCertModal: function (e) {
      e.preventDefault()
      $(this).modal({
        fadeDuration: 250
      })
      return false;
    },
  }
}

export { jModal }

